export const hostName = window.location.hostname;

const port = window.location.port;
export let isLocalApi = port >= 3000;

// Hostname
export const PRODUCTION_HOSTNAME = "admin.opticshaven.com" || "www.admin.opticshaven.com"
export const DEVELOPMENT_HOSTNAME = "dev.d37iddsoxz4dkz.amplifyapp.com"